// extracted by mini-css-extract-plugin
export default {"title":"Modals_title__1UVJu","form":"Modals_form__+MV9n","group":"Modals_group__vrNRB","delete_content":"Modals_delete_content__5ftDB","description":"Modals_description__QOCw8"};